import MaterialAssessmentSurveyBase from '../../../components/MaterialAssessmentSurveyBase/MaterialAssessmentSurveyBase';
import { MATERIAL_ASSESSMENT_PAGE_CONFIGS } from '../../../constants/materialAssessment';

function MaterialAssessmentRoundTables() {
  return <MaterialAssessmentSurveyBase config={MATERIAL_ASSESSMENT_PAGE_CONFIGS.ROUNDTABLE} />;
}

export default MaterialAssessmentRoundTables;
